import axios from "axios";
import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { Box, Tooltip } from "@mui/material";

// material-ui icons
import {
  Add,
  AssignmentLate,
  AvTimer,
  Delete,
  DeleteForever,
  Edit,
  Layers,
  Refresh,
  RestaurantMenu,
} from "@mui/icons-material";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Button from "../../components/CustomButtons/Button";

import menuKaartenStyle from "../../assets/jss/material-dashboard-pro-react/views/MenukaartenStyle";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import MainNavbar from "../../components/Navbars/MainNavbar";
import * as actions from "../../store/actions";

//Modals
import Copy from "./Modals/Copy";

//Filters
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import MassEdit from "./Modals/MassEdit";
import CategoryFilter from "../../components/Filters/CategoryFilter";
import AuthenticationWrapper from "../../auth/AuthenticationWrapper";
import VestigingFilterV2, { getVestigingFilterStateV2 } from "../../components/VestigingFilter/VestigingFilter";
import { toast } from "react-toastify";

class Menukaarten extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      copyModal: false,
      massEditModal: false,
      selectedIds: [],

      showDeleteAlert: false,
      showMoveDeleteAlert: false,
    };
  }

  jamezzTable = React.createRef();

  /**
   * Handle refresh table
   */
  refreshJamezzTable = () => {
    this.jamezzTable.current.refreshData();
  };

  /**
   * Modal functies
   */
  toggleModal(modal) {
    const newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDupliceerAction = (row) => {
    this.setState({
      selectedIds: [row[0]],
      copyModal: true,
    });
  };

  handleMultieSelect = (ids) => {
    this.setState({ selectedIds: ids });
  };

  jsonEmpty = (data) => {
    try {
      const resData = JSON.parse(data);
      switch (typeof resData) {
        case "object":
          return !Object.keys(resData).length;
        case "array":
          return !resData.length;
      }
    } catch (e) {}
    return true;
  };

  information = (data) => {
    const icons = [];
    if (data.timeTable !== null && data.timeTable !== "" && !this.jsonEmpty(data.timeTable)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Heeft een tijdschema"} tKey={"tooltip.hasTimeTable"} />}
        >
          <AvTimer
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }

    if (data.showArrangement !== null && data.showArrangement !== "" && !this.jsonEmpty(data.showArrangement)) {
      icons.push(
        <Tooltip
          placement={"bottom"}
          title={<TranslationWrapper tDefault={"Onderdeel van een arrangement"} tKey={"tooltip.belongsToArrangment"} />}
        >
          <AssignmentLate
            style={{
              fontSize: "125%",
              marginBottom: "-4px",
            }}
          />
        </Tooltip>
      );
    }
    icons.push(<span>&nbsp;{data.producten_count}</span>);
    return <div>{icons}</div>;
  };

  handleMultiDelete = () => {
    const data = {
      ids: this.state.selectedIds,
    };

    axios.post("core/kaarten/multipledelete", data).then((response) => {
      const aantal = response.data.data.deleted;
      this.toggleModal("showDeleteAlert");
      toast.warn(aantal + " items verwijderd");
      this.refreshJamezzTable();
    });
  };

  hideDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  handleMoveDelete = () => {
    const data = {
      ids: this.state.selectedIds,
    };

    axios.post("core/kaarten/moveDelete", data).then((response) => {
      const aantal = response.data.data.deleted;
      this.toggleModal("showMoveDeleteAlert");
      toast.warn(aantal + " " + getTranslation("moved to the delete salesarea"));
      this.refreshJamezzTable();
    });
  };

  hideMoveDeleteAlert = () => {
    this.setState({ showMoveDeleteAlert: false });
  };

  forceRetryTranslations = () => {
    const confirmed = confirm(
      getTranslation(
        "categories.retry.confirm",
        "Are you sure you want to force retry all category translations? This will overwrite existing translations!"
      )
    );

    if (confirmed) {
      axios
        .post("core/kaarten/forceRetryTranslations", {
          sales_area_id: this.props.filters.vestiging_id?.value,
        })
        .then((response) => {
          if (response.data) {
            toast.success(getTranslation("producten.resize.queued", "Translations queued, this may take a while"));
          } else {
            toast.error(getTranslation("producten.resize.failed", "Translations failed!"));
          }
        })
        .catch((err) => {
          toast.error(getTranslation("producten.resize.failed", "Translations failed!"));
        });
    }
  };

  deleteAllMenuItems = () => {
    const confirmed = confirm(
      getTranslation(
        "categories.retry.confirm",
        "Are you sure you want to delete all categories, products and option groups? This cannot be undone."
      )
    );

    if (confirmed) {
      axios
        .post("core/vestigingen/deleteAllMenuItems", {
          vestiging_id: this.props.filters.vestiging_id?.value?.[0],
        })
        .then((response) => {
          if (response.data) {
            toast.success(getTranslation("producten.deleteAllMenuItems.queued", "Everything is deleted!"));
            this.refreshJamezzTable();
          } else {
            toast.error(getTranslation("producten.deleteAllMenuItems.failed", "Failed"));
          }
        })
        .catch((err) => {
          toast.error(getTranslation("producten.deleteAllMenuItems.failed", "Failed"));
        });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <MainNavbar
          paginaTitel={<TranslationWrapper tDefault={"Menukaarten overzicht"} tKey={"menukaarten.pagetitle"} />}
        />
        <GridContainer sx={{ maxWidth: 1, overflowX: "auto" }}>
          <GridItem xs={12}>
            <div style={{ display: "flex", flexWrap: "wrap", padding: "8px 0px 8px 0px" }}>
              {this.props.filters.vestiging_id?.value ? (
                <>
                  <AuthenticationWrapper permissionKey={"kaarten.create"}>
                    <Link to={"./create"}>
                      <Button className={classes.marginRight} color={"success"}>
                        <Add className={classes.icons} />{" "}
                        <TranslationWrapper tDefault={"Nieuwe Menukaart"} tKey={"menukaarten.nieuw.item"} />
                      </Button>
                    </Link>
                  </AuthenticationWrapper>

                  <AuthenticationWrapper permissionKey={"producten.translate.force"}>
                    <Button className={classes.marginRight} color={"danger"} onClick={this.forceRetryTranslations}>
                      <Refresh className={classes.icons} />
                      <TranslationWrapper tDefault={"Force retry translations"} tKey={"producten.translate.force"} />
                    </Button>
                  </AuthenticationWrapper>

                  <AuthenticationWrapper permissionKey={"kaarten.delete.allMenuItems"}>
                    <Box sx={{ marginLeft: 2 }}>
                      <Button color={"danger"} onClick={this.deleteAllMenuItems}>
                        <Delete className={classes.icons} />
                        <TranslationWrapper
                          tDefault={"Delete all categories, products and option groups"}
                          tKey={"menukaarten.delete.all"}
                        />
                      </Button>
                    </Box>
                  </AuthenticationWrapper>
                </>
              ) : null}

              {this.state.selectedIds.length > 0 && this.jamezzTable.current.state.showArchive === false ? (
                <AuthenticationWrapper permissionKey={"kaarten.update"}>
                  <Button
                    className={classes.marginRight}
                    color={"success"}
                    onClick={() => this.toggleModal("massEditModal")}
                  >
                    <Edit className={classes.icons} />{" "}
                    <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.button.massEdit"} />
                  </Button>
                </AuthenticationWrapper>
              ) : null}

              {this.state.selectedIds.length > 0 && this.jamezzTable.current.state.showArchive === false ? (
                <AuthenticationWrapper permissionKey={"kaarten.update"}>
                  <Button
                    className={classes.marginRight}
                    color={"success"}
                    onClick={() => this.toggleModal("duplicateManyModal")}
                  >
                    <Layers className={classes.icons} />{" "}
                    <TranslationWrapper tDefault={"Dupliceer selectie"} tKey={"global.button.massDuplicate"} />
                  </Button>
                </AuthenticationWrapper>
              ) : null}

              {this.state.selectedIds.length > 0 && this.jamezzTable.current.state.showArchive === false ? (
                <AuthenticationWrapper permissionKey={"kaarten.delete"}>
                  <Button
                    className={classes.marginRight}
                    color={"danger"}
                    onClick={() => this.toggleModal("showDeleteAlert")}
                  >
                    <Delete className={classes.icons} />{" "}
                    <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />
                  </Button>
                </AuthenticationWrapper>
              ) : null}
              {this.state.selectedIds.length > 0 ? (
                <AuthenticationWrapper permissionKey={"kaarten.move.delete"}>
                  <Button
                    className={classes.marginRight}
                    color={"danger"}
                    onClick={() => this.toggleModal("showMoveDeleteAlert")}
                  >
                    <DeleteForever className={classes.icons} />{" "}
                    <TranslationWrapper
                      tDefault={"Move to the delete sales area"}
                      tKey={"categories.index.move.to.delete.salesarea"}
                    />
                  </Button>
                </AuthenticationWrapper>
              ) : null}
            </div>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <VestigingFilterV2 useMenukaartReferences={true} />
          <GridItem md={4} xs={12}>
            <CategoryFilter showOnlyProductsCheckbox={false} />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Layers,
                  tooltip: <TranslationWrapper tDefault={"Dupliceer"} tKey={"menukaarten.table.tooltip.dupliceer"} />,
                  action: this.handleDupliceerAction,
                },
              ]}
              dataMapping={[
                {
                  dbfield: "id",
                  editable: false,
                },
                {
                  dbfield: "media_urls.imgid",
                  postField: "imgid",
                  editable: true,
                  inputtype: "Image",
                },
                {
                  dbfield: "vestiging.systeemNaam",
                  editable: false,
                },
                {
                  dbfield: "naam",
                  editable: true,
                  inputtype: "Input",
                },
                {
                  dbfield: "categorie",
                  getDataMapping: (rowData) => {
                    return {
                      dbfield: "categorie",
                      inputtype: "Async",
                      editable: true,
                      async: {
                        url: `core/kaarten/categorie?fields=id as value,naam as label`,
                        searchField: "naam",
                      },
                      nullValue: null,
                      defaultValue:
                        rowData["category"] && rowData["categorie"]
                          ? {
                              value: rowData["categorie"],
                              label: rowData["category"],
                            }
                          : null,
                      onChange: (menukaartenTable, option, rowKey) => {
                        const newItems = [...menukaartenTable.state.items];
                        newItems[rowKey][5] = option.label;
                        menukaartenTable.setState({ items: newItems });
                      },
                    };
                  },
                },
                { dbfield: "category", hide: true },
                {
                  dbfield: "is_actief",
                  editable: true,
                  inputtype: "Switch",
                },
                { dbfield: "blocked", editable: true, inputtype: "Switch" },
                {
                  dbfield: "sortkey",
                  editable: true,
                  inputtype: "Number",
                  inputProps: {
                    type: "number",
                    decimalen: 0,
                  },
                },
                { customData: this.information },
              ]}
              delete={"kaarten.delete"}
              editLink={"./:id/edit"}
              editLinkPermission={"kaarten/:id/edit"}
              fetchUrl={"core/kaarten"}
              filters={this.props.filters}
              headerIcon={<RestaurantMenu />}
              headers={[
                {
                  label: getTranslation("menukaarten.table.id", "#"),
                  sortable: true,
                  sortKey: "id",
                },
                {
                  label: getTranslation("menukaarten.table.img", "Img"),
                  sortable: false,
                },
                {
                  label: getTranslation("menukaarten.table.verkoopgebied", "Verkoopgebied"),
                  width: "20%",
                  sortable: true,
                  sortKey: "vestiging.systeemNaam",
                },
                {
                  label: getTranslation("menukaarten.table.naam", "Naam"),
                  width: "25%",
                  sortable: true,
                  sortKey: "naam",
                },
                {
                  label: getTranslation("menukaarten.table.categorie", "Categorie"),
                  width: "20%",
                  sortable: true,
                  sortKey: "categorie",
                },
                {
                  label: getTranslation("menukaarten.table.actief", "Actief"),
                  width: "5%",
                  sortable: false,
                },
                {
                  label: getTranslation("producten.table.blocked", "blocked"),
                  width: "4%",
                  sortable: true,
                  sortKey: "blocked",
                },
                {
                  label: getTranslation("global.table.sortkey", "Sortkey"),
                  width: "7%",
                  sortable: true,
                  sortKey: "sortkey",
                },
                {
                  label: getTranslation("menukaarten.table.producten", "Products"),
                  width: "10%",
                  sortable: false,
                },
              ]}
              multieSelect
              multieSelectHandler={this.handleMultieSelect}
              reduxKey={"menukaart"}
              ref={this.jamezzTable}
              tableTitle={<TranslationWrapper tDefault={"Menukaarten"} tKey={"menukaarten.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        <Copy
          menukaartIds={this.state.selectedIds}
          open={this.state.copyModal}
          refreshTable={() => this.refreshJamezzTable()}
          toggle={() => this.toggleModal("copyModal")}
        />

        <MassEdit
          menukaartIds={this.state.selectedIds}
          open={this.state.massEditModal}
          refreshTable={() => this.refreshJamezzTable()}
          toggle={() => this.toggleModal("massEditModal")}
        />

        <Copy
          menukaartIds={this.state.selectedIds}
          open={this.state.duplicateManyModal}
          refreshTable={() => this.refreshJamezzTable()}
          toggle={() => this.toggleModal("duplicateManyModal")}
        />

        {this.state.showDeleteAlert ? (
          <SweetAlert
            cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.hideDeleteAlert}
            onConfirm={this.handleMultiDelete}
            showCancel
            style={{
              display: "block",
              marginTop: "-100px",
            }}
            title={<TranslationWrapper tDefault={"Weet je het zeker?"} tKey={"global.jamezztable.confirm"} />}
            warning
          >
            {this.state.selectedIds.length} item(s)
          </SweetAlert>
        ) : null}

        {this.state.showMoveDeleteAlert ? (
          <SweetAlert
            cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
            cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.success}
            confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
            onCancel={this.hideMoveDeleteAlert}
            onConfirm={this.handleMoveDelete}
            showCancel
            style={{
              display: "block",
              marginTop: "-100px",
            }}
            title={<TranslationWrapper tDefault={"Weet je het zeker?"} tKey={"global.jamezztable.confirm"} />}
            warning
          >
            {this.state.selectedIds.length} item(s)
          </SweetAlert>
        ) : null}
      </div>
    );
  }
}

Menukaarten.propTypes = {
  classes: PropTypes.object,
};

//REDUX
const mapStateToProps = (state) => {
  const filters = getVestigingFilterStateV2(state, true);
  if (state.filtersV2["menukaart.id"]) {
    filters["menukaart.id"] = { ...state.filtersV2["menukaart.id"] };
    filters["menukaart.id"].field = "id";
  }
  return { filters };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) =>
      dispatch({
        type: actions.SHOW_MESSAGE,
        message: message,
      }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Menukaarten, menuKaartenStyle));
